{
  "codexEntityForm": {
    "character": "角色",
    "place": "地点",
    "faction": "势力",
    "object": "物品",
    "concept": "概念",
    "editName": "编辑 {{name}}",
    "newCodexEntry": "新建设定集条目",
    "theWorldHasChangedTheDraft": "世界已变化。草稿已保留；保存前请重新加载条目。",
    "portraitChooseAnImage": "头像：选择图片",
    "change": "更改",
    "addPortrait": "添加头像",
    "portraitImage": "头像图片",
    "entryName": "条目名称",
    "name": "名称",
    "entryType": "条目类型",
    "customCategory": "自定义分类",
    "categoryEGDeityShipSpell": "分类，例如神明、舰船、咒语",
    "aliases": "别名",
    "entryAliases": "条目别名",
    "otherNamesOneAtATime": "其他名字，一次一个…",
    "tags": "标签",
    "entryTags": "条目标签",
    "themesRolesArcs": "主题、角色、弧线…",
    "collection": "合集",
    "entryCollection": "条目合集",
    "noCustomCollection": "无自定义合集",
    "folder": "文件夹",
    "entryFolder": "条目文件夹",
    "unfiled": "未归档",
    "notes": "笔记",
    "entryNotes": "条目笔记",
    "whoTheyAreWhatTheyWant": "是谁、想要什么、哪些事不能让读者太早知道…",
    "entryFields": "条目字段",
    "fields": "字段",
    "fieldTemplate": "字段模板",
    "template": "模板…",
    "schemaOf": "结构：",
    "addMissingFields": "添加缺失字段",
    "addField": "添加字段",
    "noCustomFieldYetFieldsGive": "还没有自定义字段。字段为条目提供结构化事实——年龄、效忠对象、一个秘密——供「检查」据此推理。",
    "sharedFieldNamesTypesAndOptions": "共享字段的名称、类型和选项在合集设置中管理。字段值属于这个页面。",
    "fieldNameN": "字段名称 {{n}}",
    "fieldName": "字段名称",
    "fieldTypeN": "字段类型 {{n}}",
    "unknown": "未知",
    "fieldValueN": "字段值 {{n}}",
    "select": "选择…",
    "yes": "是",
    "no": "否",
    "value": "值",
    "chooseAnEntry": "选择一个条目…",
    "eGSpringOfYear12": "例如：第 12 年的春天，或围城那天",
    "below": "下方",
    "unknownValueN": "未知值 {{n}}",
    "required": "必填",
    "sharedField": "共享字段",
    "remove": "移除",
    "confirmRemoval": "确认移除",
    "paragraph": "段落",
    "aFewLines": "几行文字…",
    "discardTheDraft": "放弃草稿？",
    "confirmReload": "确认重新加载",
    "keepEditing": "继续编辑",
    "reloadEntry": "重新加载条目",
    "cancel": "取消",
    "chooseAnImageFileForThe": "请为头像选择一个图片文件。",
    "thePortraitMustBeUnder8": "头像必须小于 8 MiB。",
    "saveEntry": "保存条目",
    "searchEntries": "搜索条目…"
  },
  "codexEntryDialog": {
    "newCodexEntry": "新建设定集条目",
    "savedToWorldCodexTheManuscript": "已保存到「世界 › 设定集」；手稿会在你输入的位置提及它。",
    "createAndMention": "创建并提及"
  },
  "continuityPanel": {
    "relationsOverTime": "随时间变化的关系",
    "checkingRelations": "正在检查关系…",
    "cancel": "取消",
    "theProjectHasChangedRunThe": "手稿或世界在这次运行后发生了变化。请重新运行检查以刷新关系。",
    "anAnalysisLimitWasReachedThe": "已达到分析上限。结果不完整。",
    "ruleApplied": "规则：「{{label}}」，{{rule}}。",
    "oneSourcePerTarget": "每个目标只能有一个来源",
    "oneTargetPerSource": "每个来源只能有一个目标",
    "interval": "从 {{start}} 到 {{end}}",
    "openScene": "打开 {{scene}}",
    "findingReferenceMissing": "指向一个已不存在的条目。",
    "findingConfirmedWithoutEvidence": "在没有文本引文的情况下被确认，所以无法核对其来源。",
    "findingEvidenceMissing": "它依赖的引文已消失。",
    "findingEvidenceNotCurrent": "它依赖的引文未经确认，或不再与文本匹配。",
    "findingExclusiveNotEvaluable": "无法按规则检查：需要方向、两端以及完整的时间跨度。",
    "findingExclusiveOverlap": "其中两项同时成立，而规则不允许这样。",
    "findingOther": "这条关系有需要检查的地方。",
    "theProjectExceedsTheLimitOf": "项目超出本次分析的上限。没有数据被改动。",
    "theAnalysisExceededItsExecutionLimit": "分析超出了执行上限。没有数据被改动。",
    "analysisCancelled": "分析已取消。",
    "checksNotCompletedTheTextAnd": "检查未完成。文本和设定没有被改动。"
  },
  "eventTimelinePanel": {
    "eventHistory": "事件历史",
    "timeline": "时间线",
    "newEvent": "新建事件",
    "searchEvents": "搜索事件",
    "searchEvents2": "搜索事件…",
    "timelineOrder": "时间线顺序",
    "storyTime": "故事时间",
    "readingOrder": "阅读顺序",
    "dateStatus": "日期状态",
    "allDates": "所有日期",
    "resolvedDates": "已确定的日期",
    "unresolvedDates": "未确定的日期",
    "filterEventsByScene": "按场景筛选事件",
    "allScenes": "所有场景",
    "scenes": "场景",
    "editEvent": "编辑事件",
    "closeEventEditor": "关闭事件编辑器",
    "theWorldHasChangedReloadThe": "世界已变化。保存前请重新加载事件；草稿字段已保留。",
    "eventTitle": "事件标题",
    "whatHappens": "发生了什么",
    "scene": "场景",
    "eventScene": "事件场景",
    "notLinked": "未关联",
    "removedSceneSceneid": "已移除的场景 — {{sceneId}}",
    "dateType": "日期类型",
    "eventDateType": "事件日期类型",
    "unknown": "未知",
    "definedInterval": "已定义的区间",
    "relativeToAnEvent": "相对于某个事件",
    "start": "开始",
    "eventStart": "事件开始",
    "endExclusive": "结束（不含）",
    "eventEnd": "事件结束",
    "referenceEvent": "参照事件",
    "select": "选择…",
    "referenceToVerifyAnchoreventid": "待核实的参照 — {{anchorEventId}}",
    "events": "事件",
    "offsetInTicks": "刻度偏移",
    "eventOffset": "事件偏移",
    "saveEvent": "保存事件",
    "closeReload": "关闭 / 重新加载…",
    "discardTheDraftChanges": "放弃草稿改动？",
    "discardDraft": "放弃草稿",
    "reloadEvent": "重新加载事件",
    "keepEditing": "继续编辑",
    "noEventMatchesTheseFiltersEvents": "没有事件符合这些筛选条件。事件是「检查」推理的依据：某事何时发生，以及读者在哪个场景得知。",
    "tickStart": "刻度 {{start}}",
    "openScene": "打开场景",
    "editTitle": "编辑 {{title}}",
    "removeTitle": "移除 {{title}}",
    "confirmEventRemoval": "确认移除事件",
    "cancel": "取消",
    "theWorldHasChangedCancelAnd": "世界已变化：请取消并重新打开确认。",
    "resolvedDate": "已确定的日期",
    "unknownDate": "未知日期",
    "missingReference": "缺失的参照",
    "timeCycle": "时间循环",
    "dateOutOfRange": "日期超出范围",
    "eventsFoundOfTotal_other": "找到 {{count}} 个事件（共 {{total}} 个）",
    "removeThisEventReferences_other": "删除此事件？有 {{count}} 处直接引用需要复查。",
    "showMoreEvents_other": "再显示 {{count}} 个事件"
  },
  "fieldEditor": {
    "choose": "选择…",
    "labelSearch": "{{label}}搜索",
    "search": "搜索…",
    "labelOptions": "{{label}}选项",
    "noMatch": "没有匹配项。",
    "optionsOnePerLine": "选项，每行一个",
    "fieldOptionsIndex": "字段选项 {{index}}",
    "addOptionIndex": "添加选项 {{index}}",
    "newOption": "新选项",
    "addOption": "添加选项",
    "fieldValueIndex": "字段值 {{index}}",
    "chooseOptions": "选择选项…",
    "chooseEntries": "选择条目…",
    "unsupportedMultiValueEditor": "不支持的多值编辑器"
  },
  "graphExplorer": {
    "relationGraph": "关系图",
    "entry": "条目",
    "filterGraphByEntry": "按条目筛选关系图",
    "all": "全部",
    "status": "状态",
    "graphRelationStatus": "关系图中的关系状态",
    "proposedAndConfirmed": "拟定与已确认",
    "confirmed": "已确认",
    "proposed": "拟定",
    "relation": "关系",
    "searchRelationInTheGraph": "在关系图中搜索关系",
    "filterAtStoryTime": "按故事时间筛选",
    "tick": "刻度",
    "graphTick": "关系图刻度",
    "includeUnknownTime": "包含未知时间",
    "enterANumericTickOrTurn": "请输入数字刻度，或关闭时间筛选。",
    "navigableRelationGraph": "可导航的关系图",
    "selectName": "选择 {{name}}",
    "entryCount_other": "{{count}} 个条目",
    "relationCount_other": "{{count}} 条关系",
    "hiddenBeyondViewLimit": "{{entries}}和{{relations}}超出了显示上限。",
    "relationsWithMissingEntries_other": "{{count}} 条关系缺少条目。",
    "unknownDurationIncluded_other": "其中 {{count}} 条时长未知的关系已包含在筛选结果中。",
    "unknownDurationExcluded_other": "其中 {{count}} 条时长未知的关系未包含在筛选结果中。"
  },
  "relationshipPanel": {
    "select": "选择…",
    "removedReference": "已移除的引用：",
    "projectRelations": "项目关系",
    "relationsOf": "关系：",
    "filterRelationsByEntry": "按条目筛选关系",
    "allEntries": "所有条目",
    "searchEntries": "搜索条目…",
    "searchRelations": "搜索关系",
    "relationOrEntry": "关系或条目",
    "newRelation": "新建关系",
    "editRelation": "编辑关系",
    "relationsLinkTwoEntries": "关系连接两个条目",
    "addTwoEntriesInTheCodex": "在设定集中至少添加两个条目，然后写下连接它们的话，比如「是……的导师」。",
    "theWorldHasChangedTheFields": "打开期间世界发生了变化。你的字段已保留；请重新加载，以便基于新数据保存。",
    "reload": "重新加载",
    "anEntry": "一个条目",
    "anotherEntry": "另一个条目",
    "relationSource": "关系来源",
    "relationType": "关系类型",
    "isTheMentorOf": "是……的导师",
    "relationTarget": "关系目标",
    "direction": "方向",
    "relationDirection": "关系方向",
    "oneWay": "单向",
    "bothWays": "双向",
    "when": "何时",
    "relationTime": "关系时间",
    "notSet": "未设置",
    "betweenTwoMoments": "两个时刻之间",
    "fromAnEvent": "从某个事件起",
    "from": "从",
    "to": "到",
    "relationStart": "关系开始",
    "relationEnd": "关系结束",
    "momentsHint": "世界时间线上的时刻；不含结束时刻。",
    "event": "事件",
    "relationEvent": "关系事件",
    "offset": "偏移",
    "relationOffset": "关系偏移",
    "offsetHint": "事件之后的时刻数；负数表示之前。",
    "status": "状态",
    "relationStatus": "关系状态",
    "proposed": "拟定",
    "confirmed": "已确认",
    "rejected": "已拒绝",
    "superseded": "已取代",
    "confirmedRelationsCountAsCanonIn": "已确认的关系在「检查」中算作设定。",
    "notes": "笔记",
    "relationNotes": "关系笔记",
    "howTheStoryShowsItAnd": "故事如何呈现它，以及哪些仍然含糊。",
    "quotes": "引文",
    "linkQuotes": "关联文本中的引文",
    "quotesLinked": "引文：{{count}}",
    "searchQuotations": "搜索引文",
    "excerptOrNote": "摘录或笔记",
    "removedQuotation": "已移除的引文：",
    "noQuotationYetAnnotateAPassage": "还没有引文。在手稿中为一个段落加批注，即可在这里引用。",
    "upTo100QuotationsShownUse": "最多显示 100 条引文。请用搜索缩小范围。",
    "saveRelation": "保存关系",
    "cancel": "取消",
    "aDeletedEntry": "已删除的条目",
    "aDeletedEvent": "已删除的事件",
    "timeBetween": "从 {{start}} 到 {{end}}",
    "timeAtEvent": "在 {{event}}",
    "timeAfterEvent": "{{event}} + {{offset}}",
    "timeBeforeEvent": "{{event}} − {{offset}}",
    "noRelationsYet": "还没有关系。",
    "noRelationMatches": "没有匹配的关系。",
    "edit": "编辑",
    "editCaption": "编辑 {{caption}}",
    "remove": "移除",
    "removeCaption": "移除 {{caption}}",
    "removeThisRelationTheChangeStays": "移除这条关系？这项更改会保留在历史中。",
    "confirmRemoval": "移除",
    "shownOfTotal": "已显示 {{total}} 条关系中的 100 条。请缩小搜索范围查看其余部分。",
    "theWorldHasChangedReloadThe": "世界已变化。保存前请重新加载这条关系。",
    "theRelationWasChangedOrRemoved": "这条关系已被更改或移除。请重新加载数据。",
    "explicitlyConfirmTheRelationBeforeSaving": "请再次选择「已确认」，使这条关系成为设定。",
    "selectTwoEntriesThatExistIn": "请选择设定集中存在的两个条目。",
    "fillInTheTimeValuesOr": "请填写时刻，或选择「未设置」。",
    "enterAValidIntervalTheEnd": "结束必须晚于开始。",
    "selectAnExistingEventAsThe": "请选择仍然存在的事件。",
    "theSelectedQuotationIsNoLonger": "所选引文已不存在。",
    "checkTheRelationTextAndThe": "请检查这条关系的文字和笔记。",
    "theChangeWasNotSavedReload": "更改未保存。请重新加载数据后重试。"
  },
  "useWorldReplication": {
    "signInToTheLinkedAccount": "请登录关联的账号，并检查你对此项目的访问权限。你的本地更改已保留。",
    "syncTheManuscriptWithThisServer": "请先将手稿与此服务器同步，再关联它的「世界」。",
    "theWorldChangedAfterTheComparison": "对比之后「世界」发生了变化。请重新查看当前副本。",
    "aConfirmationOrRestoredRecordNeeds": "确认或已恢复的记录需要明确审阅后才能同步。",
    "anAttachmentOrRemoteCopyFailed": "有附件或远程副本未通过校验。你的本地「世界」已保留。",
    "theseChangesExceedASyncLimit": "这些更改超出同步限制，或必须一并应用。你的本地「世界」和待处理更改已保留。",
    "syncPausedYourLocalChangesAre": "同步已暂停。你的本地更改已保留。",
    "newMapNeedsPlan": "新地图包含在 Ink 和 Press 中。地图保留在这台设备上，「世界」暂不同步：请移除新地图，或选择方案后再同步。",
    "worldSyncCouldNotFinishCheck": "世界同步未能完成。请检查网络后重试。你的本地更改已保留。"
  },
  "vaultFolders": {
    "folderName": "文件夹 {{name}}",
    "editFolder": "编辑文件夹",
    "newSubfolder": "新建子文件夹",
    "moveContentsBeforeRemoving": "移除前请先移走内容",
    "removeFolder": "移除文件夹",
    "folderActionsName": "文件夹 {{name}} 的操作",
    "chooseThisFolderWhenEditingA": "编辑页面时选择此文件夹。",
    "projectFolders": "项目文件夹",
    "folders": "文件夹",
    "newFolder": "新建文件夹",
    "groupPagesFromAnyCollection": "把任意合集中的页面归为一组。",
    "foldersOrganizePagesWithoutChangingTheir": "文件夹只整理页面，不改变它们的合集或内容。",
    "cancel": "取消",
    "saveFolder": "保存文件夹",
    "name": "名称",
    "folderName2": "文件夹名称",
    "inside": "位于",
    "parentFolder": "上级文件夹",
    "projectRoot": "项目根目录",
    "removeEmptyFolder": "移除空文件夹？",
    "removeNameFromTheProject": "把「{{name}}」从项目中移除？"
  },
  "vaultTable": {
    "unavailableEntry": "不可用的条目",
    "vaultTable": "档案库表格",
    "pages": "页面",
    "searchVaultTable": "搜索档案库表格",
    "searchPages": "搜索页面…",
    "tableCollection": "表格合集",
    "allCollections": "所有合集",
    "noCustomCollection": "无自定义合集",
    "tableFolder": "表格文件夹",
    "allFolders": "所有文件夹",
    "unfiled": "未归档",
    "scrollableVaultTable": "可滚动的档案库表格",
    "name": "名称",
    "collection": "合集",
    "folder": "文件夹",
    "noPagesMatchTheseFilters": "没有页面符合这些筛选条件。",
    "none": "无",
    "yes": "是",
    "no": "否",
    "pagesShown_other": "共 {{count}} 页，显示 {{shown}} 页"
  },
  "vaultTree": {
    "blue": "蓝色",
    "emerald": "祖母绿",
    "gold": "金色",
    "violet": "紫罗兰",
    "rose": "玫瑰",
    "amber": "琥珀",
    "teal": "青绿",
    "slate": "石板灰",
    "crimson": "绯红",
    "bark": "树皮",
    "forest": "森林",
    "navy": "藏青",
    "orchid": "兰花",
    "saffron": "藏红花",
    "ink": "墨色",
    "ember": "余烬",
    "concept": "概念",
    "character": "角色",
    "place": "地点",
    "faction": "势力",
    "object": "物品",
    "vault": "档案库",
    "newCollection": "新建合集",
    "vaultView": "档案库视图",
    "pages": "页面",
    "table": "表格",
    "pagesMarkedUnassignedKeepTheirPrevious": "标为未分配的页面保留之前的字段。编辑页面以选择它的合集。",
    "filterPages": "筛选页面",
    "filterPages2": "筛选页面…",
    "worldVault": "世界档案库",
    "removeCollectionName": "移除合集 {{name}}",
    "collectionSettingsForName": "{{name}} 的合集设置",
    "iconAndColour": "图标与颜色",
    "newPageInName": "在 {{name}} 中新建页面",
    "noPageYetAddTheFirst": "还没有页面——用 + 添加第一个。",
    "nothingHereYet": "这里还没有内容。",
    "removeEmptyCollection": "移除空合集？",
    "removeNameAndItsSchema": "移除「{{name}}」及其结构？",
    "removeCollection": "移除合集",
    "text": "文本",
    "theSvgMustBeUnder16": "SVG 必须小于 16 KiB。",
    "thisFileIsNotAUsable": "该文件不是可用的 SVG（脚本和外部引用会被移除；根元素必须是 <svg>）。",
    "collectionName": "合集：{{name}}",
    "sharedFieldsApplyToEveryPage": "共享字段适用于此合集中的每个页面。每个页面也可以有自己的字段。",
    "cancel": "取消",
    "saving": "正在保存…",
    "saveCollection": "保存合集",
    "createCollection": "创建合集",
    "identity": "基本信息",
    "nameAndIconAsTheTree": "名称和图标，将按此显示在树和页面中。",
    "name": "名称",
    "collectionName2": "合集名称",
    "magic": "魔法",
    "aCollectionWithThisNameAlready": "已存在同名合集。",
    "icon": "图标",
    "iconSource": "图标来源",
    "lucide181": "Lucide（181）",
    "yourSvg": "你的 SVG",
    "collectionIcon": "合集图标",
    "searchLucideIcons": "搜索 Lucide 图标",
    "searchIconsCastleSwordMoon": "搜索图标——城堡、剑、月亮…",
    "loadingIcons": "正在加载图标…",
    "lucideIcon": "Lucide 图标",
    "noIconMatches": "没有匹配的图标。",
    "chooseAnSvgFile": "选择 SVG 文件",
    "customSvgIcon": "自定义 SVG 图标",
    "upTo16KibScriptsLinks": "最大 16 KiB。脚本、链接和外部引用会被移除；请在文件中使用 currentColor，合集颜色才会生效。",
    "colour": "颜色",
    "aPresetOneYouUsedRecently": "预设、最近用过的，或从色轮中选取你自己的。",
    "collectionColour": "合集颜色",
    "recent": "最近",
    "useHex": "使用 {{hex}}",
    "kindOfPage": "页面类型",
    "everyPageIsACodexEntry": "每个页面都是某一类的设定集条目；类型决定「检查」、@ 提及和关系图如何处理它，并让它在各处保持同一种颜色。",
    "collectionBaseKind": "合集的基础类型",
    "magicOrShipsConceptDeitiesOr": "魔法或舰船 → 概念 · 神明或家族 → 角色或势力 · 城镇合集 → 地点。",
    "sharedFields": "共享字段",
    "thePropertiesOfTheCollectionValues": "合集的属性——值保存在每个页面上，页面也可以再添加自己的字段。",
    "collectionTemplate": "合集模板",
    "template": "模板…",
    "addField": "添加字段",
    "exampleMagicLevelNumberRarityChoice": "示例：魔法 → 等级（数字）· 稀有度（选项：普通、稀有、传说）· 获得时间（故事日期）· 传授者（条目链接）。",
    "collectionFieldNameValue": "合集字段名称 {{value}}",
    "fieldName": "字段名称",
    "collectionFieldTypeValue": "合集字段类型 {{value}}",
    "collectionFieldOptionsValue": "合集字段选项 {{value}}",
    "optionsOnePerLine": "选项，每行一个",
    "required": "必填",
    "requiredCollectionFieldValue": "必填的合集字段 {{value}}",
    "removeCollectionFieldValue": "移除合集字段 {{value}}",
    "yesNo": "是 / 否",
    "multipleChoice": "多选",
    "storyDate": "故事日期",
    "entryLink": "条目链接",
    "multipleEntryLinks": "多个条目链接",
    "fieldParagraph": "段落",
    "fieldNumber": "数字",
    "fieldChoice": "选项"
  },
  "worldCloudPanel": {
    "worldCloudVersions": "世界云端版本",
    "includesCodexPagesCollectionsFoldersFacts": "包括设定集页面、合集、文件夹、事实、关系和附件。请明确地发布或下载版本。手稿使用场景同步。",
    "compareVersions": "对比版本",
    "recoverPreviousWorld": "恢复之前的世界…",
    "deviceRevision": "设备修订版",
    "accountVersionRemoteversion": "账号版本 {{remoteVersion}}",
    "firstAccountVersion": "账号首个版本",
    "uploadDeviceVersion": "上传设备版本…",
    "useAccountVersion": "使用账号版本…",
    "confirmTransfer": "确认传输",
    "replaceWorldOnThisDeviceWith": "用此版本替换这台设备上的「世界」？会先保留当前「世界」和附件的副本。手稿文本保持不变。",
    "saveThisCopyToYourAccount": "把这份副本保存到你的账号？账号的先前版本会保留。",
    "restoreWorldFromBeforeTheLast": "恢复到上一次传输之前的「世界」？之后的编辑会使这次恢复无法进行。",
    "confirm": "确认",
    "cancel": "取消",
    "transferring": "正在传输…",
    "codexPages": "设定集页面",
    "updateStoryideBeforePublishingChangesTo": "发布对此档案库的更改之前，请先更新 Musael。",
    "theAccountVersionChangedCompareAgain": "账号版本已变化。应用前请重新对比。",
    "worldChangedOnThisDeviceCompare": "这台设备上的「世界」已变化。应用前请重新对比。",
    "accountVersionStorageIsFullPrevious": "账号版本存储已满。之前的副本已保留。",
    "anAttachmentFailedItsIntegrityCheck": "有附件未通过完整性校验。没有本地副本被替换。",
    "theAccountCopyFailedItsIntegrity": "账号副本未通过完整性校验。",
    "noRecoveryCopyIsAvailableFor": "这次传输没有可用的恢复副本。",
    "anIdentifierIsAlreadyUsedIn": "有标识符已在另一个项目中使用。",
    "openOrSyncTheManuscriptWith": "请先打开手稿，或将其与你的账号同步。",
    "yourAccountDoesNotHaveThe": "你的账号没有所需的权限。",
    "signInAgainThisSessionWas": "请重新登录。此会话已被撤销。",
    "transferCancelled": "传输已取消。",
    "transferFailedCheckYourConnectionAnd": "传输失败。请检查网络后重新对比。",
    "couldNotReadTheRecoveryCopy": "无法读取恢复副本。",
    "mondoPrecedenteRipristinato": "已恢复之前的世界。",
    "accountVersionVersionSaved": "账号版本 {{version}} 已保存。",
    "versionVersionAppliedToWorldOn": "版本 {{version}} 已应用到这台设备上的「世界」。",
    "cancellationRequested": "已请求取消。",
    "labelFacts": "事实",
    "labelEvents": "事件",
    "labelKnowledge": "认知",
    "labelAnnotations": "批注",
    "labelRelationships": "关系",
    "labelAttachments": "附件",
    "labelCollections": "合集",
    "labelFolders": "文件夹",
    "changedCount_other": "{{count}} 项已更改"
  },
  "worldMaps": {
    "character": "角色",
    "place": "地点",
    "object": "物品",
    "faction": "势力",
    "concept": "概念",
    "pinOf": "标记：{{name}}",
    "pinMissing": "缺失条目的标记",
    "missingEntry": "缺失的条目",
    "zoom": "缩放",
    "zoomIn": "放大",
    "zoomOut": "缩小",
    "fitToView": "适应视图",
    "newMap": "新建地图",
    "newMapDescription": "一个地方的图片，可以在上面给那里的人物、地点和物品打标记。",
    "cancel": "取消",
    "saving": "正在保存…",
    "createMap": "创建地图",
    "mapOf": "地图：",
    "aNewPlace": "一个新地方",
    "placeName": "地点名称",
    "placeNamePlaceholder": "The Salt Coast",
    "picture": "图片",
    "choosePicture": "选择 PNG、JPEG、WebP 或 GIF",
    "pictureHint": "最大 16 MB。它会成为该条目的附件之一。",
    "maps": "地图",
    "mapsLead": "把条目标在你的地点图片上。带有自己地图的已标记地点会打开那张地图。",
    "noMapsYet": "还没有地图",
    "noMapsText": "为一个地点配一张图片，然后把属于那里的条目标上去。",
    "addTheFirstMap": "添加第一张地图",
    "onePin": "1 个标记",
    "pins": "{{count}} 个标记",
    "inPlace": "在 {{place}} 上",
    "chooseAnEntryOrName": "请选择一个条目，或为标记写一个名称。",
    "mapTrail": "上级地图",
    "doneAdding": "完成",
    "addPin": "添加标记",
    "labels": "标签",
    "replacePicture": "替换图片",
    "removeMap": "移除地图",
    "hintClick": "在地图上点击标记的位置。",
    "hintChoose": "在右侧选择标记所指向的对象。",
    "pictureMissing": "这张地图的图片还不在这台设备上。",
    "pinDetails": "标记详情",
    "newPin": "新建标记",
    "entry": "条目",
    "chooseAnEntry": "选择条目",
    "noEntryLabelOnly": "无条目，仅标签",
    "labelOnTheMap": "地图上的标签",
    "labelDefault": "条目的名称",
    "labelRequired": "没有条目时必填",
    "placePin": "放置标记",
    "label": "标签",
    "openEntry": "打开条目",
    "openItsMap": "打开它的地图",
    "position": "距左 {{x}}%，距上 {{y}}%",
    "removePin": "移除标记",
    "noPinsYet": "还没有标记。点「添加标记」，然后点击地图。",
    "shownOn": "显示于",
    "openEntryOf": "打开 {{name}}",
    "removeMapTitle": "移除 {{name}} 的地图？",
    "removeMapMessage": "标记会随之删除。图片保留在条目的附件中。"
  },
  "worldPanel": {
    "checks": "检查",
    "findAndFixConsistencyIssuesIn": "把你世界中的事实、事件和关系与手稿对照。不使用 AI。",
    "running": "运行中…",
    "runChecks": "运行检查",
    "lastRunAt": "上次运行于 {{time}}",
    "oneAtATime": "一次一个",
    "exclusiveRelation": "排他关系",
    "noRelationIsExclusive": "没有排他关系",
    "exclusivityType": "排他类型",
    "oneSourcePerTarget": "每个目标只能有一个来源",
    "oneTargetPerSource": "每个来源只能有一个目标",
    "oneAtATimeHint": "同一时间只能对一方成立的关系，比如「拥有」：同一时刻有两个人拥有同一件东西，就会成为冲突。",
    "rulesNeedRelations": "规则使用你的关系。请在「关联」中添加一个，比如「拥有」，然后在这里把它设为排他。",
    "results": "结果",
    "whatTheChecksLookFor": "检查查什么",
    "twoHoldersAtOnce": "同时有两个持有者",
    "eventsOutOfOrder": "事件顺序错乱",
    "quotedPastItsLimit": "超出限制的引用",
    "linksToDeletedEntries": "指向已删除条目的链接",
    "notesThatLostTheirPlace": "失去位置的笔记",
    "relationsOverTime": "随时间变化的关系",
    "scopeOwnership": "在相同的时刻被两个条目持有的同一件东西，依据已确认的事实。",
    "scopeFlashback": "一个事件被安排在世界中更晚发生的事件之后阅读：闪回，或疏漏。",
    "scopeReveal": "一个事实在场景中被引用，晚于你为它设定的最后一个场景。",
    "scopeOrphans": "指向已不存在的条目或资料库卡片的笔记和事实。",
    "scopeAnchors": "被引用段落的文字在其场景中移动或改变了。",
    "scopeRelations": "关系对照上面的规则，以及它们所引用的引文。",
    "filterResults": "筛选结果",
    "all": "全部",
    "conflicts": "冲突",
    "warnings": "警告",
    "needsData": "需要数据",
    "noIssuesFound": "未发现问题",
    "theExecutedRulesFoundNoViolation": "没有任何内容违反你设定的事实和规则。检查只知道你记录过的内容。",
    "notEnoughData": "数据不足",
    "quotesInTheText": "文本中的引文",
    "anchorInPlace": "在原位",
    "anchorMoved": "已移动",
    "anchorGone": "已消失",
    "reAnchor": "重新锚定",
    "openScene": "打开场景",
    "checkedAt": "检查于 {{time}}。",
    "twoHold": "{{a}} 和 {{b}} 在同一时间都持有「{{object}}」。",
    "heldTwice": "{{a}} 在相同的时刻两次持有「{{object}}」。",
    "flashbackSentence": "「{{earlier}}」在世界中发生在「{{later}}」之前，却排在其后阅读：这是闪回，除非你并非有意。",
    "revealSentence": "「{{fact}}」出现在 {{scene}} 中，晚于你为它设定的最后一个场景。",
    "allowedUpToScene": "允许到场景 {{scene}}",
    "orphanFactSentence": "一个事实（「{{fact}}」）关于一个已被删除的条目。",
    "orphanNoteSentence": "「{{excerpt}}」上的笔记指向一个已删除的条目。",
    "orphanConceptSentence": "「{{excerpt}}」上的笔记指向一张已不存在的资料库卡片。",
    "movedSentence": "「{{excerpt}}」在 {{scene}} 中移动了：重新锚定笔记让它跟上。",
    "eventWithoutTime": "「{{title}}」在世界中没有时间，因此无法检查其顺序。",
    "factWithoutTime": "「{{fact}}」没有时间跨度，因此无法检查其持有者。",
    "recordWithoutTime": "有一条记录没有时间，因此无法检查。",
    "aDeletedEntry": "已删除的条目",
    "aDeletedEvent": "已删除的事件",
    "aScene": "一个场景",
    "fromTo": "从 {{start}} 到 {{end}}",
    "relativeToAnEvent": "相对于某个事件",
    "timeNotSet": "未设置",
    "facts": "事实",
    "factsLead": "你对每个条目的陈述。检查会读取你已确认的事实，并与手稿对照。",
    "entries": "条目",
    "addAnEntry": "添加条目",
    "addTheFirstEntry": "添加第一个条目",
    "newEntityName": "新条目名称",
    "entityType": "条目类型",
    "addEntity": "添加条目",
    "character": "角色",
    "place": "地点",
    "object": "物品",
    "faction": "势力",
    "other": "其他",
    "deleteEntityReferencesBecomeOrphaned": "删除条目（引用将成为孤立项）",
    "deleteEntityName": "删除条目 {{name}}",
    "noFactYet": "还没有关于 {{name}} 的事实。新事实先作为拟定；确认后才算数。",
    "proposed": "拟定",
    "confirmed": "已确认",
    "rejected": "已拒绝",
    "superseded": "已取代",
    "worldFact": "世界事实",
    "characterBelief": "信念",
    "testimony": "证词",
    "authorHypothesis": "假设",
    "confirm": "确认",
    "confirmExplicitApproval": "确认（明确批准）",
    "newFactAbout": "关于 {{name}} 的新事实",
    "predicatePlaceholder": "拥有",
    "predicate": "谓语",
    "valuePlaceholder": "那把剑",
    "value": "值",
    "kind": "类型",
    "epistemicKind": "认知类型",
    "kindHint": "只有世界事实算作真相；信念、证词和假设会被保留，但不作为设定检查。",
    "when": "何时",
    "timeKind": "时间类型",
    "betweenTwoMoments": "两个时刻之间",
    "from": "从",
    "to": "到",
    "startTick": "起始刻度",
    "endTick": "结束刻度",
    "momentsHint": "世界时间线上的时刻；不含结束时刻。",
    "reveal": "揭示",
    "maximumRevealNarrativeIndex": "最大揭示（叙事索引）",
    "noLimit": "无限制",
    "sceneNumbered": "{{n}}. {{title}}",
    "revealHint": "此事实在较晚场景中的引用会被标记。",
    "addFactProposed": "作为拟定添加",
    "selectAnEntityToSeeAnd": "选择一个条目来查看并添加它的事实。",
    "noEntityYet": "还没有条目。请在上方或设定集中添加角色、地点或物品。",
    "resultDetails": "结果详情",
    "conflict": "冲突",
    "warning": "警告",
    "whatWasCompared": "对比了什么",
    "whatToDo": "该怎么做",
    "comparedOwnership": "已确认、带时间跨度的世界事实。同一件东西的两个持有者不能重叠。",
    "comparedFlashback": "每个事件在世界中的时间，对照它的场景在书中的顺序。",
    "comparedReveal": "你为一个事实设定的最后一个场景，对照引用它的场景。",
    "comparedOrphans": "每条笔记和事实，对照现有的条目和资料库卡片。",
    "comparedAnchors": "每条笔记的引文，对照场景当前的文本。",
    "confirmOnlyOneOwnerInThe": "让这些时刻只留一个持有者：缩小其中一个时间跨度，或把一个事实改回拟定。",
    "ifTheSceneIsADeliberate": "如果该场景是有意的闪回，就保留。否则请移动场景，或更改事件的时间。",
    "raiseTheMaximumRevealSceneOf": "为这个事实允许更晚的场景，或把引文提前。",
    "restoreTheMissingEntityFromThe": "从设定集历史中恢复该条目，或删除指向它的笔记或事实。",
    "useReAnchorManualOnThe": "对结果中的引文使用「重新锚定」，或打开场景并重新选中该段落。",
    "giveTheEventOrFactAn": "给它一个世界中的时间，或不设时间：检查会保持沉默，而不是猜测。",
    "selectAResult": "选择一个结果",
    "detailsConstraintsAndSuggestedFixesAppear": "这里会显示对比了什么以及该怎么做。",
    "thisAnnotationCannotBeReAnchored": "这条笔记无法重新锚定：「{{excerpt}}」在场景中缺失或出现不止一次。",
    "revisionTools": "修订工具",
    "loadingRevisionTools": "正在加载修订工具…"
  },
  "worldReplicationPanel": {
    "theContentChangedWhileItWas": "确认期间内容已变化。请选择你审阅过的内容和批准。",
    "theseChangesCannotBeCombinedInto": "这些更改无法合并成有效的「世界」。请选择要保留的完整版本；两份副本都会留在恢复区。",
    "thisDevice": "这台设备",
    "yourAccount": "你的账号",
    "viewWorld": "查看世界",
    "previousSharedValue": "此前的共享值",
    "theActionCouldNotFinishYour": "操作未能完成。你的本地更改已保留。",
    "worldSync": "世界同步",
    "syncCodexPagesFactsTimelinesCollections": "跨设备同步设定集页面、事实、时间线、合集和附件。笔记和草图在下方独立同步。",
    "syncWorldAutomatically": "自动同步世界",
    "n1PendingChange": "1 项待处理的更改",
    "pendingPendingChanges": "{{pending}} 项待处理的更改",
    "syncNow": "立即同步",
    "exportRecoveryCopies": "导出恢复副本",
    "compareBeforeSyncing": "同步前对比",
    "signInToTheLinkedAccount": "请登录关联的账号以同步。本地更改仍会保存。",
    "signInToCompareYourWorld": "登录后即可对比你的「世界」并启用同步。",
    "chooseYourStartingWorld": "选择你的起始「世界」",
    "bothCopiesHaveTheSameContent": "两份副本内容相同。",
    "keepTheWorldOnThisDevice": "保留这台设备上的「世界」，或使用账号中的副本。原先的本地「世界」和附件会保留在恢复区。",
    "keepThisDeviceSync": "保留这台设备并同步",
    "useAccountCopySync": "使用账号副本并同步",
    "cancel": "取消",
    "reviewConcurrentChanges": "审阅并发更改",
    "chooseEachValueToKeepOther": "为每个值选择要保留的版本。其他更改会自动合并。两个版本都可恢复。",
    "applyReviewedChoices": "应用审阅后的选择",
    "syncingWorldAndAttachments": "正在同步世界和附件…",
    "codexPages": "设定集页面",
    "onThisDevice": "在这台设备上",
    "waitingToSync": "等待同步",
    "syncing": "正在同步…",
    "upToDate": "已是最新",
    "reviewNeeded": "需要审阅",
    "emptyText": "（空文本）",
    "emptyList": "（空列表）",
    "worldStructure": "世界结构",
    "labelFacts": "事实",
    "labelEvents": "事件",
    "labelKnowledge": "认知",
    "labelAnnotations": "批注",
    "labelRelationships": "关系",
    "labelAttachments": "附件",
    "labelCollections": "合集",
    "labelFolders": "文件夹",
    "paused": "已暂停",
    "addedCount_other": "新增 {{count}} 项",
    "removedCount_other": "移除 {{count}} 项",
    "changedCount_other": "更改 {{count}} 项",
    "removedValue": "已移除",
    "emptyValue": "空"
  },
  "worldReviewTools": {
    "deletedEntry": "已删除的条目",
    "timeUnknown": "时间未知",
    "storyTimeInterval": "故事时间区间",
    "relativeToEventPreserved": "相对于某个事件（已保留）",
    "from": "从",
    "until": "直到",
    "characterKnowledge": "角色的认知",
    "couldNotCheckTheSavedManuscriptRetry": "无法检查已保存的手稿。请重试。",
    "revisionTools": "修订工具",
    "changeImpact": "更改的影响",
    "whatPointsToThisRecord": "哪些内容指向这条记录？",
    "explicitLinksOnlyIncludingIndirectLinksChangingARecord": "仅限明确的链接，包括间接链接。更改一条记录不会重写依赖它的记录。",
    "impactRecord": "影响分析的记录",
    "chooseARecord": "选择一条记录",
    "linkedRecordsWorldRevision": "条关联记录 · 世界修订版",
    "directLink": "直接链接",
    "missingSourceScene": "缺失的来源场景",
    "noExplicitRecordLinksToThisEntryUnlinkedProse": "没有任何记录明确链接到这个条目。未链接的正文不在这次检查范围内。",
    "whenDidTheyLearnIt": "角色何时得知的？",
    "recordAcquisitionAndUseOnTheSameStoryTime": "在同一条故事时间轴上记录获得和使用。猜测与信念分开记录；章节顺序绝不当作故事时间。",
    "recordKnowledge": "记录认知",
    "couldNotSaveCheckTheIntervalsOrCancelAnd": "无法保存。请检查区间，或在世界已变化时取消并重新打开。",
    "character": "角色",
    "knowledgeCharacter": "认知角色",
    "chooseACharacter": "选择一个角色",
    "fact": "事实",
    "knowledgeFact": "认知事实",
    "chooseAConfirmedWorldFact": "选择一个已确认的世界事实",
    "acquired": "获得",
    "acquisitionSource": "获得来源",
    "noSourceAttached": "未附来源",
    "use": "使用",
    "scene": "场景",
    "chooseAScene": "选择一个场景",
    "knownInformation": "已知信息",
    "belief": "信念",
    "guess": "猜测",
    "passageSource": "段落来源",
    "noPassageAttached": "未附段落",
    "removeUse": "移除使用记录",
    "addUse": "添加使用记录",
    "confirmAndSave": "确认并保存",
    "cancel": "取消",
    "missingFact": "缺失的事实",
    "atUnknownRelativeTime": "时间未知/相对",
    "edit": "编辑",
    "couldNotRemoveTheRecordRefreshAndRetry": "无法移除这条记录。请刷新后重试。",
    "checkSavedKnowledge": "检查已保存的认知",
    "theWorldChangedSinceThisResultRunTheCheck": "自这个结果之后世界已变化。请重新运行检查。",
    "recordedUseIsEarlierThanAcquisition": "记录的使用早于获得",
    "recordedTimesAreInOrder": "记录的时间顺序正确",
    "beliefOrGuessNotAKnowledgeConflict": "信念或猜测——不算认知冲突",
    "notEnoughInformationToCompare": "信息不足，无法比较",
    "attachedPassagesMatchTheSavedText": "附加的段落与已保存文本相符",
    "aSourceIsMissingStaleOrBelongsToAnother": "来源缺失、已过期，或属于另一个场景",
    "authorRecordedTimesPassagesAreNotVerified": "作者记录的时间；段落未经验证",
    "openScene": "打开场景",
    "noConfirmedKnowledgeUsesToCompare": "没有可对比的已确认认知使用记录。",
    "openNamedScene": "打开 {{title}}",
    "recordSummary": "使用次数：{{count}} · {{lifecycle}} · 获得于 {{time}}",
    "checkSummary": "检查于 {{time}} · 已记录使用 {{count}} 次。编辑正文后请刷新。",
    "resultsLimitedTo500Records": "结果最多显示 500 条记录",
    "linksAway": "相隔 {{depth}} 层链接",
    "useNKind": "用法 {{n}} 的类型",
    "useN": "用法 {{n}}",
    "useNSource": "用法 {{n}} 的来源",
    "checking": "正在检查…"
  },
  "worldSection": {
    "overview": "概览",
    "vault": "档案库",
    "timeline": "时间线",
    "connections": "关联",
    "references": "引用",
    "checks": "检查",
    "analysis": "分析",
    "characters": "角色",
    "locations": "地点",
    "factions": "势力",
    "objects": "物品",
    "concepts": "概念",
    "worldViews": "世界视图",
    "world": "世界",
    "browseByType": "按类型浏览",
    "filterByType": "按类型筛选",
    "all": "全部",
    "newEntry": "新建条目",
    "cercaNelCodex": "搜索设定集",
    "searchEntries": "搜索条目…",
    "entry": "个条目",
    "entries": "个条目",
    "alsoAliases": "又称：{{aliases}}",
    "noEntriesYetCreateTheFirst": "还没有条目。创建第一个角色、地点或势力。",
    "noEntryMatches": "没有匹配的条目。",
    "editName": "编辑 {{name}}",
    "edit": "编辑",
    "archive": "归档",
    "confirmArchive": "确认归档",
    "notesAndSketches": "笔记与草图",
    "alsoKnownAs": "又名",
    "addADescriptionOneLineThat": "添加一段描述——用一行说明这是什么。",
    "none": "无",
    "yes": "是",
    "no": "否",
    "removedEntry": "已移除的条目",
    "unavailableEntry": "不可用的条目",
    "noNotesYetEditTheEntry": "还没有笔记。编辑条目来描述它。",
    "linkedScenes": "关联的场景",
    "showTheEntriesOfABook": "显示某本书的条目",
    "allBooks": "所有书",
    "bookLine": "第 {{number}} 册 · {{title}}",
    "inNoBookYet": "尚不属于任何一本书",
    "scenesThatMentionThisEntryBy": "按名称或别名提到该条目的场景会显示在这里。",
    "facts": "事实",
    "noFactRecordedFactsAreAdded": "没有记录的事实。事实在「检查」中添加和批准。",
    "relations": "关系",
    "noRelationYet": "还没有关系。",
    "proposed": " · 拟定",
    "viewAll": "查看全部",
    "attachments": "附件",
    "attachAnImageToUseIt": "附加一张图片，将其用作头像。",
    "kib": "KiB",
    "open": "打开",
    "remove": "移除",
    "addAttachment": "添加附件",
    "stateAtStoryTime": "故事时间的状态",
    "tick": "刻度",
    "factsWithoutACompleteInterval": "个事实没有完整的区间。",
    "selectAnEntry": "选择一个条目",
    "charactersPlacesFactionsAndObjectsLive": "角色、地点、势力和物品都在这里，附带它们的事实、关系和附件。",
    "recentChanges": "最近的更改",
    "undoChange": "撤销更改",
    "worldTimeline": "世界时间线",
    "eventsPeopleAndPlacesInA": "事件、人物和地点，放在更大的背景中。",
    "noEventYet": "还没有事件",
    "addTheFirstEventWithA": "添加第一个有故事时间的事件，或者在知道之前先让时间保持未知。",
    "tick2": "刻度",
    "plotEvent": "情节事件",
    "worldEvent": "世界事件",
    "openScene": "打开场景",
    "unknownTime": "时间未知",
    "unknown": "未知",
    "seeHowYourWorldSPeople": "看看你世界中的人物、地点和理念是如何连接的。",
    "connectionsView": "关联视图",
    "graph": "关系图",
    "list": "列表",
    "nothingToConnectYet": "暂时没有可连接的内容",
    "createEntriesInTheCodexAnd": "在设定集中创建条目，并在列表视图中把它们关联起来。",
    "selectedEntry": "选中的条目",
    "relationSummary": "关系摘要",
    "noSceneMentionsThisEntryYet": "还没有场景提到这个条目。",
    "openInCodex": "在设定集中打开",
    "selectANodeToSeeIts": "选择一个节点来查看它的关系和场景。",
    "annotationsAnchoredInTheManuscriptAnd": "锚定在手稿中的批注，以及你为世界保留的文件。",
    "addFile": "添加文件",
    "annotations": "批注",
    "selectTextInTheManuscriptAnd": "在手稿中选中文本，用「批注」来锚定一种修辞手法、一个条目或一条笔记。",
    "scene": "场景",
    "device": "修辞手法",
    "entity": "条目",
    "note": "笔记",
    "imagesPdfsNotesAndAudioYou": "你附加到世界或条目上的图片、PDF、笔记和音频。",
    "linked": "已关联",
    "orphan": "孤立",
    "openFile": "打开文件",
    "referenceDetails": "引用详情",
    "textAnnotation": "文本批注",
    "kind": "类型",
    "anchor": "锚点",
    "concept": "概念",
    "created": "创建于",
    "anchorStatesValidStaleOrphanedAnd": "锚点状态（有效、过期、孤立）和重新锚定都在「检查」中计算。",
    "attachment": "附件",
    "type": "类型",
    "size": "大小",
    "linkedTo": "关联到",
    "added": "添加于",
    "confirmRemove": "确认移除",
    "selectAnAnnotationOrAFile": "选择一个批注或文件。",
    "exploreTheShapeOfYourStory": "探索你故事的形状：场景间的长度、出场与密度。",
    "sceneLength": "场景长度",
    "wordsPerScene": "每个场景的字数",
    "noScenesYet": "还没有场景。",
    "titleFmtWords": "{{title}}：{{fmt}} 字",
    "entityDensity": "条目密度",
    "codexMentionsPerScene": "每个场景中的设定集提及",
    "titleMentionsMentions": "{{title}}：{{mentions}} 次提及",
    "characterAppearanceMap": "角色出场图",
    "aDotWhereACharacterIs": "在某个场景中提到角色处标一个点",
    "addCharactersToTheCodexAnd": "把角色添加到设定集，并在场景中提到他们。",
    "thisScene": "这个场景",
    "words": "字数",
    "paragraphs": "段落",
    "sentencesEst": "句子（估计）",
    "distinctWords": "不重复的词",
    "annotatedDevices": "已批注的修辞手法",
    "n1000Words": "/ 每 1,000 字",
    "repetitions": "重复",
    "exportHtml": "导出 HTML",
    "exportTxt": "导出 TXT",
    "events": "事件",
    "confirmedFacts": "已确认的事实",
    "recentlyChanged": "最近更改",
    "changesToTheWorldWillBe": "对世界的更改会列在这里，每一条都可撤销。",
    "undo": "撤销",
    "startHere": "从这里开始",
    "overviewEmptyLead": "你故事中的人物、地点和事件，与它们出现的场景相连。",
    "addACharacter": "添加角色",
    "addACharacterText": "是谁、想要什么、有什么在阻拦。",
    "addAPlace": "添加地点",
    "addAPlaceText": "场景发生的地方：一座城、一艘船、一个房间。",
    "addAnEventText": "故事中发生的事，可以有日期，也可以没有。",
    "inThisWorld": "在这个世界里",
    "createAnEntry": "创建条目",
    "aCharacterAPlaceAFaction": "角色、地点、势力、物品或概念。",
    "addAnEvent": "添加事件",
    "withAnExactStoryTimeOr": "带确切的故事时间，或时间未知。",
    "runTheChecks": "运行检查",
    "deterministicRulesOwnershipOrderAnchorsOrphans": "持有者、顺序、揭示以及随时间变化的关系，与文本对照。",
    "loadingTheWorld": "正在加载世界…",
    "maps": "地图",
    "openItsMap": "打开它的地图",
    "addAMap": "添加地图",
    "pinnedOn": "标记于",
    "typeCharacter": "角色",
    "typeLocation": "地点",
    "typeObject": "物品",
    "typeFaction": "派系",
    "typeConcept": "概念",
    "annotationsToReAnchor_other": "{{count}} 条批注需要重新锚定。"
  }
}
